import { create } from 'zustand';
import { useHospitalProfileStore } from './hospitalProfile';

interface WallpaperStore {
  wallpaperUrl: string | null;
  wallpaperOpacity: number;
  isLoaded: boolean;
  setWallpaper: (url: string | null, opacity?: number) => void;
  loadWallpaper: () => void;
  clearWallpaper: () => void;
  updateCSS: () => void;
}

export const useWallpaperStore = create<WallpaperStore>((set, get) => ({
  wallpaperUrl: null,
  wallpaperOpacity: 0.2,
  isLoaded: false,

  setWallpaper: (url: string | null, opacity: number = 0.2) => {
    set({ wallpaperUrl: url, wallpaperOpacity: opacity });
    get().updateCSS();
  },

  loadWallpaper: () => {
    const hospitalProfile = useHospitalProfileStore.getState().profile;
    const wallpaperUrl = hospitalProfile.wallpaperUrl;
    const wallpaperOpacity = hospitalProfile.wallpaperOpacity || 0.2;
    
    set({ 
      wallpaperUrl: wallpaperUrl || null, 
      wallpaperOpacity,
      isLoaded: true 
    });
    get().updateCSS();
  },

  clearWallpaper: () => {
    set({ wallpaperUrl: null, wallpaperOpacity: 0.2 });
    get().updateCSS();
  },

  updateCSS: () => {
    const { wallpaperUrl, wallpaperOpacity } = get();
    
    // Update CSS custom properties
    const root = document.documentElement;
    
    if (wallpaperUrl) {
      root.style.setProperty('--wallpaper-url', `url(${wallpaperUrl})`);
      root.style.setProperty('--wallpaper-opacity', wallpaperOpacity.toString());
      
      // Force update body background with a small delay to ensure image loads
      setTimeout(() => {
        document.body.style.backgroundImage = 
          `linear-gradient(rgba(255, 255, 255, ${wallpaperOpacity}), rgba(255, 255, 255, ${wallpaperOpacity})), url(${wallpaperUrl})`;
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center';
        document.body.style.backgroundRepeat = 'no-repeat';
        
        // Force a repaint
        document.body.style.display = 'none';
        document.body.offsetHeight; // Trigger reflow
        document.body.style.display = '';
      }, 100);
    } else {
      // Reset to default
      root.style.removeProperty('--wallpaper-url');
      root.style.removeProperty('--wallpaper-opacity');
      
      document.body.style.backgroundImage = '';
      document.body.style.backgroundAttachment = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundPosition = '';
      document.body.style.backgroundRepeat = '';
    }
  }
}));
